import { useEffect, useState } from "react";
import { NavbarDefault } from "./NavbarDefault";
import { usePageContext } from "vike-react/usePageContext";


export const Navbar = () => {
  const { urlPathname } = usePageContext();
  const [scrolled, setScrolled] = useState(false);

  const isHomePage = urlPathname === "/" || urlPathname === "/platform" || urlPathname === "/solutions";

  useEffect(() => {
    const handleScroll = () => {
      if (isHomePage) {
        setScrolled(window.scrollY > 0);
      } else {
        setScrolled(true);
      }
    };

    handleScroll();

    if (isHomePage) {
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, [isHomePage]);

  return <NavbarDefault scrolled={scrolled} isHome={isHomePage} />;
};
